import { createContext } from "react";

const SaveGuardPromptHandlersContext = createContext<{
  setStayHandler: (newStayHandler: (() => void) | null) => void;
  setLeaveHandler: (newLeaveHandler: (() => void) | null) => void;
}>({
  setStayHandler: () => {
    throw new Error(
      "Cannot set stay handler outside a SaveGuardFunctionContext"
    );
  },
  setLeaveHandler: () => {
    throw new Error(
      "Cannot set leave handler outside a SaveGuardFunctionContext"
    );
  },
});

export default SaveGuardPromptHandlersContext;
